<script lang="ts">
    import type DataProvider from "../services/data.provider";
    import type ServiceProvider from "../services/service.provider";
    import WhispererList from "./WhispererList.svelte";
    import { clickOutside } from "../../../core/directives/click-outside.directive";

    export let dataProvider: DataProvider;
    export let serviceProvider: ServiceProvider;

    let whispererList: WhispererList | any;

    let searchString: string = null
    let displayWhisperer = false
    $: isListDisplayed = !!(searchString && displayWhisperer)

    const onKeyUp = (e: any): void => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        dataProvider.searchString = e.target.value || null;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        whispererList.onKeyUpProvider(e);
    };
    const onFocus = (e: any): void => {
        if (e.target.value) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            dataProvider.searchString = e.target.value;
            // eslint-disable-next-line no-undef
            setTimeout(() => {
                serviceProvider.whispererSearchService.searchWhispererSubs = true;
            }, 200);
        }
    };
    const onSubmit = (): void => {
        serviceProvider.searchService.submitSearch();
        serviceProvider.whispererSearchService.searchWhispererSubs = false;
    };
    const handleClickOutside = (): void => {
        serviceProvider.whispererSearchService.searchWhispererSubs = false;
    }
    
    // Tip for refactoring: handle better
    window.addEventListener(
        "popstate",
        function () {
            serviceProvider.searchService.submitFromUrl()
            dataProvider = dataProvider;
        },
        false
    )

    dataProvider.searchStringSubs.subscribe(
        (search: string | null) => (searchString = search)
    )
    serviceProvider.whispererSearchService.searchWhispererSubs.subscribe(
        (display: boolean) => (displayWhisperer = display)
    )
</script>

<div class="bno-search autocomplete-visible">
    <div class="bno-search__inner">
        <form
            on:submit|preventDefault={onSubmit}
            use:clickOutside
            on:click_outside={handleClickOutside}
            aria-label="Vyhledávání"
        >
            <div class="bno-form-control">
                <input
                    id="search-input-{dataProvider.uniqueId}"
                    on:keyup={onKeyUp}
                    on:focus={onFocus}
                    value={dataProvider.searchParameterFromUrl}
                    class="bno-form-control__input bno-form-control__input--standalone"
                    type="text"
                    autocomplete="off"
                    aria-required="true"
                    aria-disabled="false"
                    role="searchbox"
                    aria-autocomplete="list"
                    aria-controls="bno-autocomplete-list-{dataProvider.uniqueId}"
                    aria-expanded="{isListDisplayed}"
                    aria-multiline="false"
                    aria-label="Vyhledávání"
                    placeholder={dataProvider.placeholder}
                />
                <WhispererList
                    {dataProvider}
                    {serviceProvider}
                    bind:this={whispererList}
                />
                <label
                    class="bno-form-control__label u-sr-only"
                    for="search-input-{dataProvider.uniqueId}"
                >
                    {dataProvider.cta}
                </label>
            </div>
            <button
                class="bno-button bno-button--secondary"
                type="submit"
                aria-label="Odeslat formulář vyhledávání"
            >
                {dataProvider.cta}
            </button>
        </form>
    </div>
</div>
